import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PRICING } from "@/lib/pricing";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <header className="bg-white border-b border-border">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center gap-4">
          <Link to="/" className="flex items-center">
            <img src="/logo-lockup.svg" alt="CartControl" className="h-7 w-auto" />
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-8">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-gray-400 mb-10">Last updated: October 2026</p>

        <div className="prose prose-slate prose-sm max-w-none space-y-8">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Service Description</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              CartControl is a browser extension and web application that helps users track online spending by parsing purchase receipt emails and providing real-time budget warnings on supported ecommerce websites.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Subscription Terms</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              CartControl offers a 30-day free trial with full access to Premium features. When the trial ends, your account moves to the free Basic plan unless you subscribe to Premium. Premium is available at {PRICING.monthly.priceWithInterval} or {PRICING.yearly.priceWithInterval}, billed through Stripe at the interval you choose. If you subscribe during your free trial, your first charge happens when the trial ends.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Auto-Renewal & Cancellation</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Premium subscriptions renew automatically at the end of each billing period (monthly or yearly, depending on your plan) unless you cancel before the renewal date. You may cancel at any time from your account settings. If you cancel during your free trial, you will not be charged and you keep full access until your trial ends. If you cancel a paid subscription, you keep Premium access until the end of your current billing period.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">No Financial Advice</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              CartControl is a spending awareness tool. It does not provide financial advice, investment recommendations, or credit counseling. Budget calculations are estimates based on parsed receipt data and may not reflect your complete financial picture.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Limitation of Liability</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              CartControl is provided "as is" without warranties of any kind. We are not liable for any financial decisions made based on information provided by the service, missed purchase receipts, incorrect spending calculations, or any indirect damages arising from use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Refund Policy</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              If you are unsatisfied with your Premium subscription, contact us within 7 days of purchase for a full refund. Refund requests can be sent to <a href="mailto:hello@cartcontrol.io" className="text-gray-900 underline">hello@cartcontrol.io</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Contact</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              For questions about these terms, contact us at <a href="mailto:hello@cartcontrol.io" className="text-gray-900 underline">hello@cartcontrol.io</a>.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
